import { styled } from 'styled-components';

import { mq, rowBothMiddle } from '@/shared/ui/styled';

export const StyledSolutionHave = styled.div`
    margin-top: 42px;

    & .text-center {
        text-align: center;

        ${mq.lt.sm} {
            text-align: start;
        }
    }
`;

export const StyledSolutionHaveContainer = styled.div`
    display: flex;
    gap: 24px;

    ${mq.lt.md} {
        flex-direction: column;
        gap: 16px;
    }
`;

export const StyledSolutionHaveSteps = styled.div`
    flex: 1 1 50%;
`;

export const StyledSolutionHaveStepsStep = styled.div`
    ${rowBothMiddle};
    background: ${({ theme }) => theme.color.secondary};
    font-size: ${({ theme }) => theme.fontSize.lg};
    border-radius: 12px;
    padding: 31px 16px;
    margin-bottom: 16px;
    font-weight: 700;

    span {
        display: block;
        width: 37px;
        height: 37px;
        position: relative;
        margin-right: 32px;
    }

    &:last-child {
        margin-bottom: 0;
    }

    ${mq.lt.lg} {
        font-size: ${({ theme }) => theme.fontSize.md};
        padding: 22px 16px;
    }
    ${mq.lt.md} {
        font-size: ${({ theme }) => theme.fontSize.sm};
    }
    ${mq.lt.sm} {
        span {
            width: 29px;
            height: 29px;
            margin-right: 24px;
        }
    }
`;

export const StyledSolutionHaveImage = styled.div`
    ${rowBothMiddle};
    flex: 1 1 50%;
    background: ${({ theme }) => theme.color.secondary};
    border-radius: 12px;
    padding: 31px 16px;

    span {
        display: block;
        width: 287px;
        height: 213px;
        position: relative;
    }
`;
